
export class ProjectTransferResponseDto {
  Id?: number;
  costCenterId: number;
  empId:number;
  // empName:string;
  projectId: number;
  projectName:string;
  attenEligibility: boolean;
  assignedDate?: Date;
  unassignedDate?: Date;
  isActive?: boolean;
  createdAt? : Date | any;
  createdUser? : number;
  updatedAt? : Date | any;
  updatedUser? : number;
  versionFlag? : number;
  status?: boolean;
}